module.exports = __webpack_public_path__ + "img/haarlem_landing_large.8a0f841e.jpg";